import { TICKET_STUB_COPY } from './TicketStub.constants';

/**
 * Compact "time until lock" formatter for the TicketStub stat cell.
 *
 *  - ≥ 1 day  → `Xd Yh`
 *  - ≥ 1 hour → `Yh Zm`
 *  - < 1 hour → `Zm`
 *  - past     → `pastLabel`
 *
 * Computed once at render — never ticks down. `now` is injectable for tests.
 */
export function formatLocksIn(targetIso: string, pastLabel: string, now: Date = new Date()): string {
  const targetMs = Date.parse(targetIso);
  if (Number.isNaN(targetMs)) return pastLabel;

  const diffMs = targetMs - now.getTime();
  if (diffMs <= 0) return pastLabel;

  const totalMinutes = Math.floor(diffMs / 60_000);
  const totalHours = Math.floor(totalMinutes / 60);
  const days = Math.floor(totalHours / 24);
  const hours = totalHours - days * 24;
  const minutes = totalMinutes - totalHours * 60;

  if (days > 0) return `${days}d ${hours}h`;
  if (totalHours > 0) return `${totalHours}h ${minutes}m`;
  return `${totalMinutes}m`;
}

/**
 * What the lock cell reads once the first kickoff has passed.
 *
 * A competition that is still running is "Under way", not "Locked": squads stay joinable after
 * kickoff (specs/worldcup-late-join) and a latecomer still picks every remaining match. Only a
 * competition that is over has nothing left to pick.
 */
export function getLocksPastLabel(lifecycle: string | null | undefined): string {
  const normalized = String(lifecycle ?? '').toUpperCase();
  return normalized === 'FINISHED' || normalized === 'ARCHIVED'
    ? TICKET_STUB_COPY.LOCKS_FINISHED_LABEL
    : TICKET_STUB_COPY.LOCKS_PAST_LABEL;
}
